import React from 'react'
import { usePaginationContext } from './context'
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap'
import * as Icon from 'react-feather'
import { FormattedMessage } from 'react-intl'

export default function Limit() {
  const [dropdownOpen, setDropdownOpen] = React.useState(false)
  function handleDropdownToggle() {
    setDropdownOpen(prevState => !prevState)
  }

  const { currentLimit, handleLimit, totalItems } = usePaginationContext()
  return (
    <>
      <div className="d-flex flex-row justify-content-center align-items-center">
        <Dropdown
          isOpen={dropdownOpen}
          toggle={handleDropdownToggle}
          defaultValue={currentLimit}
          direction="up"
        >
          <DropdownToggle caret>
            {currentLimit}{' '}
            {dropdownOpen ? (
              <Icon.ChevronUp color="#A8A8A8" size="15" />
            ) : (
              <Icon.ChevronDown color="#A8A8A8" size="15" />
            )}
          </DropdownToggle>

          <DropdownMenu>
            {[10, 20, 30, 40, 50].map(el => (
              <DropdownItem
                key={el}
                disabled={el > totalItems}
                onClick={() => handleLimit(el)}
              >
                {el}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
        <div className="ml-2">
          <FormattedMessage id={'per page'} />
        </div>
      </div>
    </>
  )
}
